import { myTeamsStore, authStore } from '@stores'
import { isNumber } from '@helpers/utils.js'
import {
  TEAM_MEMBER_LEVEL_ADMINISTRATOR,
  TEAM_MEMBER_LEVEL_MODERATOR,
  TEAM_MEMBER_LEVEL_MANAGER,
} from '@config/options.js'

export default function () {
  const { myTeams } = myTeamsStore()
  const { isSuperAdmin, isAccountClosed } = authStore()

  /**
   * @param {string} gameNameId
   * @param {'leader' | 'admin' | 'manager' | 'moderator'} scope
   */
  function hasPermissionForGame(gameNameId = '', scope) {
    return hasPermissionByNameId({
      resource: 'game',
      nameId: gameNameId,
      scope,
    })
  }

  /**
   * @param {{
   *  resource: String,
   *  nameId: String,
   *  scope: 'leader' | 'admin' | 'manager' | 'moderator'
   * }} options
   */
  function hasPermissionByNameId({ resource, nameId, scope }) {
    if (isSuperAdmin()) {
      return true
    }

    if (!resource || !nameId) {
      return false
    }

    const item = _getAccess({ resource, id: nameId })
    return !!item && _hasAccess(item, scope) && !isAccountClosed.value
  }

  function _hasAccess(item, scope) {
    if (scope === 'leader') {
      return !!item?.access?.is_leader
    }

    if (scope === 'moderator') scope = TEAM_MEMBER_LEVEL_MODERATOR
    else if (scope === 'manager') scope = TEAM_MEMBER_LEVEL_MANAGER
    else if (scope === 'admin') scope = TEAM_MEMBER_LEVEL_ADMINISTRATOR
    else throw new Error('Invalid scope')

    return item?.access?.level >= scope
  }

  function _getAccess({ resource, id }) {
    const key = isNumber(id) ? 'resource_id' : 'name_id'

    return (
      myTeams.value &&
      myTeams.value.find((item) => {
        return (
          item[key] == id &&
          item.resource_type === resource &&
          item.access?.invite_pending === 0
        )
      })
    )
  }

  return {
    hasPermissionByNameId,
    hasPermissionForGame,
  }
}
